import styled from 'styled-components'

export const Container = styled.span`
  margin: 0 auto;
  padding: .5rem;

  .loading {
    animation: loading 0.5s infinite linear;
  }

  @-webkit-keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }

  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
`
